<template>
  <div class="block">
    <div class="line">
      <div class="line-name">
        发票抬头
      </div>
      <div class="line-value"
      >
      {{invoiceListDetail.title}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        纳税人识别号
      </div>
      <div class="line-value">
        {{invoiceListDetail.taxpayer_number}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        开户行
      </div>
      <div class="line-value">
        {{invoiceListDetail.bank_name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        对公账号
      </div>
       <div class="line-value"
       >
        {{invoiceListDetail.bank_account}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        注册地址
      </div>
      <div class="line-value"
      >
      {{invoiceListDetail.register_addr}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        公司电话
      </div>
      <div class="line-value">
        {{invoiceListDetail.company_phone}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        收件人
      </div>
      <div class="line-value"
      >
        {{invoiceListDetail.recipients_name}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        手机号码
      </div>
      <div class="line-value">
        {{invoiceListDetail.recipients_phone}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        邮政编码
      </div>
      <div class="line-value">
        {{invoiceListDetail.recipients_postcode}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        收件地址
      </div>
      <div class="line-value">
        {{invoiceListDetail.recipients_addr}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        申请时间
      </div>
      <div class="line-value">
        {{invoiceListDetail.create_time}}
      </div>
    </div>
    <div class="line">
      <div class="line-name">
        开票时间
      </div>
      <div class="line-value">
        {{invoiceListDetail.invoice_time}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoiceListDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.block {
  padding-bottom: 11px;

  .line {
    display: flex;
    padding-top: 10px;
    line-height: 20px;

    .line-name {
      width: 100px;
      font-size: 12px;
      color: #405060;
    }

    .line-value {
      width: 168px;
      margin-left: 10px;
      font-size: 12px;
      color: #80848F;
      overflow: hidden;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/agInvoiceSearch/InvoiceDetailLeft.vue